module.exports = __webpack_public_path__ + "static/media/opensans-regular.3ed9575d.ttf";